module.exports = __webpack_public_path__ + "static/flag2-bd8afb0e850851eb678bef75ce838883.png";